import { useCallback, useRef } from 'react';

import { useAppContext } from '../../../store/App/utils/useAppContext';
import { usePrivacyOverrides } from '../../../store/App/utils/usePrivacyOverrides';
import {
  resendUserMessage,
  sendMessageFail,
  sendUserMessage,
  updateChat,
} from '../../../store/transcript/actions';
import { useTranscriptContext } from '../../../store/transcript/utils/useTranscriptContext';

export const useSendMessage = () => {
  const { state, dispatch } = useTranscriptContext();
  const { endpoints } = useAppContext();
  const overrides = usePrivacyOverrides();

  const stateRef = useRef(state);
  stateRef.current = state;

  const overridesRef = useRef(overrides);
  overridesRef.current = overrides;

  const dispatchAndSend = useCallback(
    (message: string, messageId: string) => {
      const { sessionId } = stateRef.current;
      if (!sessionId) {
        dispatch(sendMessageFail(messageId));
        return Promise.reject(new Error('Session Id not found'));
      }
      return endpoints
        .sendMessage(message, sessionId, overridesRef.current)
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(sendMessageFail(messageId));
        });
    },
    [dispatch, endpoints],
  );

  const sendMessage = useCallback(
    (message: string, messageId: string) => {
      dispatch(sendUserMessage({ message, messageId }));
      return dispatchAndSend(message, messageId);
    },
    [dispatch, dispatchAndSend],
  );

  const resendMessage = useCallback(
    (message: string, messageId: string) => {
      dispatch(resendUserMessage(messageId));
      return dispatchAndSend(message, messageId);
    },
    [dispatch, dispatchAndSend],
  );

  return {
    sendMessage,
    resendMessage,
  };
};
